<div class="tags-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_TAGS.DESCRIPTION' | translate }}
    </p>
    <tf-settings-tags-list />
  </div>
</div>
